import { useEffect, useState } from "react";
import { getTwilioSettings } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { MessageSquare, CheckCircle2, AlertCircle, Loader2 } from "lucide-react";

export default function TwilioSettings({ userRecordId }) {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userRecordId) return;
    setLoading(true);
    getTwilioSettings(userRecordId)
      .then((res) => setStatus(res))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [userRecordId]);

  return (
    <Card
      className="rounded-2xl border-zinc-200 p-4"
      data-testid="twilio-settings-card"
    >
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-lg bg-violet-50 flex items-center justify-center shrink-0">
          <MessageSquare className="text-violet-700" size={18} />
        </div>
        <div className="flex-1">
          <div className="font-semibold text-zinc-900 flex items-center gap-2 flex-wrap">
            SMS (Twilio)
            {loading ? (
              <Loader2 size={12} className="animate-spin text-zinc-400" />
            ) : status?.system_configured ? (
              <span
                className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider font-semibold bg-emerald-50 text-emerald-700 px-1.5 py-0.5 rounded"
                data-testid="twilio-status-system"
              >
                <CheckCircle2 size={10} /> Using system number
              </span>
            ) : (
              <span
                className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider font-semibold bg-amber-50 text-amber-700 px-1.5 py-0.5 rounded"
                data-testid="twilio-status-none"
              >
                <AlertCircle size={10} /> Not configured
              </span>
            )}
          </div>
          <p className="text-xs text-zinc-500 mt-0.5">
            {status?.system_configured
              ? `SMS will be sent from ${status.system_from_number} until you add per-dealer credentials.`
              : "SMS sending is not yet set up."}
          </p>

          {status && !status.dealer_fields_in_airtable && (
            <div
              className="mt-3 rounded-lg bg-amber-50 border border-amber-200 p-2.5 text-[11px] text-amber-800"
              data-testid="twilio-needs-fields"
            >
              <div className="font-semibold mb-0.5">To use your own Twilio number:</div>
              Add 3 fields to the <span className="font-mono">Users</span> table:
              <span className="font-mono"> twilio_account_sid</span>,
              <span className="font-mono"> twilio_auth_token</span>,
              <span className="font-mono"> twilio_from_number</span>.
              Once they exist, the per-dealer credential form will unlock here.
            </div>
          )}
        </div>
      </div>
    </Card>
  );
}
